import { Button } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = {
  time: number;
  retries: number;
  onButtonPress: () => void;
};

export default function ResendButton({ time, retries, onButtonPress }: Props) {
  const tailwind = useTailwind();
  const [word, icon] = getCombo(retries);

  const text = time ? `${word} en ${time}` : word;
  return (
    <Button
      mode="contained"
      style={tailwind("mb-2")}
      icon={icon}
      disabled={!!time}
      onPress={onButtonPress}
    >
      {text}
    </Button>
  );
}

const getCombo = (retries: number) => {
  switch (retries) {
    case 0:
      return ["Solicitar código por WhatsApp", "whatsapp"];
    case 1:
    default:
      return ["Pedir ayuda por WhatsApp", "whatsapp"];
  }
};
